import { render, staticRenderFns } from "./LegacyWrapper.vue?vue&type=template&id=cd446e16&"
import script from "./LegacyWrapper.vue?vue&type=script&lang=js&"
export * from "./LegacyWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports